// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2bFUm","search":"Settings_search__1uCWU","filter":"Settings_filter__1Bane"};